import _styled from "@emotion/styled-base";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { css } from "@emotion/core";
import * as React from "react";
import { remRhythm } from "../css";
import { jsx as ___EmotionJSX } from "@emotion/core";

var StyledComboboxOption = /*#__PURE__*/_styled("div", {
  target: "e1e9pj590"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("label:base;padding:", remRhythm(1 / 8), " ", remRhythm(3 / 8), ";margin:0;color:", theme.colors.heading, ";cursor:pointer;");
}, function (_ref2) {
  var selected = _ref2.selected,
      theme = _ref2.theme;
  return selected && /*#__PURE__*/css("label:selected;background-color:", theme.colors.blues[50], ";");
}, function (_ref3) {
  var highlighted = _ref3.highlighted,
      theme = _ref3.theme;
  return highlighted && /*#__PURE__*/css("label:highlighted;background-color:", theme.colors.grays[50], ";color:", theme.colors.heading, ";");
});

StyledComboboxOption.displayName = "StyledComboboxOption";

var ComboboxOption = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ComboboxOption, _React$Component);

  function ComboboxOption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ComboboxOption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        item = _this$props.item,
        selectedItem = _this$props.selectedItem,
        index = _this$props.index,
        highlightedIndex = _this$props.highlightedIndex,
        getItemProps = _this$props.getItemProps,
        toLabel = _this$props.toLabel,
        toValue = _this$props.toValue;
    var highlighted = highlightedIndex != null && highlightedIndex === index;
    var selected = selectedItem != null && toValue(selectedItem) === toValue(item);
    return ___EmotionJSX(StyledComboboxOption, _extends({}, getItemProps({
      item: item
    }), {
      highlighted: highlighted,
      selected: selected
    }), children || toLabel(item));
  };

  return ComboboxOption;
}(React.Component);

export { ComboboxOption as default };